/* Zubaz: product size swatches sometimes render out of order (e.g.
   S, M, 2XL, L, XL) because the variant option values are stored in the wrong
   order upstream. This reorders the SwatchKing size buttons into the natural
   run S -> M -> L -> XL -> 2XL -> ... -> 6XL on the fly. Display-only: it only
   ever reorders a list whose EVERY item is a recognized size, so team and
   color swatch lists are never touched. */
(function () {
  'use strict';

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  // Returns a sort rank for a size label, or null when the label isn't a size.
  function sizeRank(label) {
    var s = String(label || '')
      .toUpperCase()
      .replace(/\./g, '')
      .replace(/\s+/g, ' ')
      .trim();
    var map = {
      '2XS': 0, 'XXS': 0, 'XX-SMALL': 0, '2X-SMALL': 0,
      'XS': 1, 'X-SMALL': 1, 'XSMALL': 1,
      'S': 2, 'SM': 2, 'SMALL': 2,
      'M': 3, 'MED': 3, 'MEDIUM': 3,
      'L': 4, 'LG': 4, 'LARGE': 4,
      'XL': 5, '1XL': 5, '1X': 5, 'X-LARGE': 5, 'XLARGE': 5,
      'XXL': 6, '2XL': 6, '2X': 6, 'XX-LARGE': 6, '2X-LARGE': 6,
      'XXXL': 7, '3XL': 7, '3X': 7, 'XXX-LARGE': 7, '3X-LARGE': 7,
      '4XL': 8, '4X': 8, 'XXXXL': 8, '4X-LARGE': 8,
      '5XL': 9, '5X': 9, 'XXXXXL': 9, '5X-LARGE': 9,
      '6XL': 10, '6X': 10, '6X-LARGE': 10
    };
    return Object.prototype.hasOwnProperty.call(map, s) ? map[s] : null;
  }

  function labelFor(item) {
    var t = item.querySelector('.swatch-button-title-text');
    return t ? t.textContent : item.getAttribute('data-value') || item.textContent;
  }

  function sortList(list) {
    var items = toArray(list.children).filter(function (el) {
      return el.nodeType === 1 && el.querySelector && el.querySelector('.swatch-button-title-text');
    });
    if (items.length < 3) return;

    var ranked = items.map(function (el, i) {
      return { el: el, rank: sizeRank(labelFor(el)), i: i };
    });
    // Only reorder a pure size list — this guard protects team/color swatches.
    if (ranked.some(function (r) { return r.rank === null; })) return;

    var sorted = ranked.slice().sort(function (a, b) {
      return a.rank - b.rank || a.i - b.i;
    });
    // Already ordered? do nothing — keeps the MutationObserver from looping.
    if (sorted.every(function (r, idx) { return r.i === idx; })) return;

    sorted.forEach(function (r) { list.appendChild(r.el); });
  }

  function sortAll() {
    toArray(document.querySelectorAll('ul.swatch-view-button')).forEach(sortList);
  }

  function init() {
    sortAll();
    // SwatchKing renders/re-renders asynchronously — re-run a few times.
    // sortAll is a no-op once a list is ordered, so this can't thrash.
    var tries = 0;
    var timer = setInterval(function () {
      sortAll();
      if (++tries >= 12) clearInterval(timer);
    }, 350);

    var scheduled = false;
    var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      raf(function () { scheduled = false; sortAll(); });
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
